module.exports = __webpack_public_path__ + "static/media/iconfont.e735f67e.eot";